module.exports = new __parcel__URL__("empty-state-workflow-work-suggestions-darkmode.64a3a206.svg").toString();